import { Injectable } from '@angular/core';
import { PreparationCenter, ZipCode} from '../_models';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment.prod';
import { retryWhen, map, delay, concatMap, catchError, finalize, mergeMap, switchMap, switchMapTo, withLatestFrom, share, tap } from 'rxjs/operators';
import { Observable, of, throwError, iif } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DeliveryZonesService {

  constructor(private http: HttpClient,
    private translate: TranslateService,) { }



  getPreparationCenters(): Observable<PreparationCenter[]> {
    return this.http.get<PreparationCenter[]>(`${environment.API_ENDPOINT}zones/preparationcenters`).pipe(delay(environment.FAKE_DELAY),
      retryWhen(errors => {
        return errors.pipe(
          switchMap((error) => (error.status != 503) ? throwError(error) : of(error)),
          // Use concat map to keep the errors in order and make sure they aren't executed in parallel
          concatMap((e, i) =>
            // Executes a conditional Observable depending on the result of the first argument
            iif(
              () => i > environment.MAX_RETRY_COUNT,
              // If the condition is true we throw the error (the last error)
              throwError(e),
              // Otherwise we pipe this back into our stream and delay the retry
              of(e).pipe(delay(environment.RETRY_DELAY))
            )
          ));
      }),
      map(result => result.map(prepcenter => new PreparationCenter(prepcenter))),
      catchError(err => {
        // this.toastr.warning(err.statusText + '->' + err.message);
        return throwError(err);
      }),
    ); 
  }

  getZipCodes(): Observable<ZipCode[]> {
    return this.http.get<ZipCode[]>(`${environment.API_ENDPOINT}zones/zipcodes`).pipe(delay(environment.FAKE_DELAY),
      retryWhen(errors => {
        return errors.pipe(
          switchMap((error) => (error.status != 503) ? throwError(error) : of(error)),
          // Use concat map to keep the errors in order and make sure they aren't executed in parallel
          concatMap((e, i) =>
            // Executes a conditional Observable depending on the result of the first argument
            iif(
              () => i > environment.MAX_RETRY_COUNT,
              // If the condition is true we throw the error (the last error)
              throwError(e),
              // Otherwise we pipe this back into our stream and delay the retry
              of(e).pipe(delay(environment.RETRY_DELAY))
            )
          ));
      }),
      map(result => result.map(zipCode => new ZipCode(zipCode))),
      catchError(err => {
        // this.toastr.warning(err.statusText + '->' + err.message);
        return throwError(err);
      }),
    );
  }
}
